<script lang="ts">
	import Link from "./Link.svelte";

	export let href: string | undefined = undefined;
</script>

{#if href}
	<Link
		noUnderline
		{href}
		class="text-primary border-primary text-5xs rounded-full border px-1.5 py-1 font-semibold uppercase leading-none tracking-widest"
	>
		<slot />
	</Link>
{:else}
	<span
		class="text-primary border-primary text-5xs text-nowrap rounded-full border px-1.5 py-1 font-semibold uppercase leading-none tracking-widest"
	>
		<slot />
	</span>
{/if}
